$shm_hitalama_command_palette $mol_view
	opened? false
	query? \
	selected_id? \
	auto /
		<= search_focus null
		<= pointerdown_listener $shm_listener /
			\pointerdown
			<= pointerdown_handler null
	sub /
		^ panel_visible /
			<= Panel $mol_view
				plugins /
					<= Hovered $shm_hitalama_hovered
						hovered? <=> panel_hovered? false
				sub /
					<= Search $mol_string
						hint \Поиск команд
						value? <=> query? \
						submit? <=> submit? null
						event *
							^
							keydown? <=> search_keydown? null
					<= List $mol_view
						sub <= command_rows /$mol_view
	Command_row* $mol_button_minor
		click? <=> command_click*? null
		attr *
			^
			selected <= command_selected* false
		sub /
			<= Command_label* $mol_dimmer
				haystack <= command_title* \
				needle <= query? \
